<template>
  <div class="header-box">
    <div class="index-header">
      <div class="left box" @click="goPage('/home')">
        <img src="static/logo.png" alt="">
        <div class="title">国家危险化学品安全公共服务互联网平台</div></div>


      <div class="right box">
        <div class="phone">
          <img src="static/phone.png" alt="" style="width: 18px;height: 18px">
          <div style="color: #FFF111;margin-left: 10px">公共服务电话:0532-83889191</div>
        </div>
        <div class="message">
          <img src="static/message.png" alt="">
          <div style="margin-left: 10px" @click="goPage('/messageBoard')">留言板</div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "headers",
  props: {},
  components: {},
  data() {
    return {
    }
  },
  // 进入加载，Dom未编译前
  created() {
  },
  // 进入加载，Dom编译完成后
  mounted() {
  },
  // 监听事件
  watch: {},
  // 计算事件
  // 计算事件
  computed: {
  },
  // 方法盒子
  methods: {
    goPage(router){
      this.$router.push(router)
    }
  }
}
</script>

<style scoped lang="scss">
.header-box{
  width: 100%;
  height: 80px;
  // position: fixed;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  margin-top: 36px;
}
.index-header {
  width: 100%;
  height: 80px;
  display: flex;
  position: absolute;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .box{
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }
  .left{
    margin-left: 50px;
  }
  .right{
    width: 429px;
    height: 52px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    margin-right: 50px;
    color: #fff;
    .phone{
      width: 291px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .message{
      width: 138px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 5px;
    }
  }
  .title{
    color: #fff;
    font-weight: bolder;
    font-size: 26px;
    margin-left: 24px;
  }
}
</style>
